import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Collapse from '../Collapse/Collapse'
import Button from '../../1_Atoms/Button/Button';
import IconText from '../../1_Atoms/IconText/IconText';
import Link from '../../1_Atoms/Link/Link';
import { Svg } from '../../1_Atoms/Svg/Svg';
import { generateGoogleDirection } from '../../../utils/googleMapHelper'
import Hours from './Hours/Hours';
import { languageController } from '../../../controllers/language/languageController';
import { formatPhoneNumber, openModal, setItemOnLocalStorage } from '../../../utils/helpers';
import { localStorageKeys } from '../../../utils/constants';

const openSendBuildModal = () => {
  const modal = document.getElementById('mz-react-send-build-to-dealer-modal');
  if (modal) {
    openModal(modal);
  }
}

function DealerCard({
  dealerData,
  isLean,
  index,
  isActive,
  onClick,
  userCurrentPos,
  onSelect,
  isSelected,
  BaSALink,
  BaTDLink,
  GaQLink,
  isEmbeddedOnBnP,
  currentLang,
  cardsRef,
}) {
  if (!dealerData) return '';

  const { name, address_line_1, city, post_code, website, phone_number, hours, ev_service, geolocation } = dealerData;

  const formattedPhoneNumber = phone_number ? formatPhoneNumber(phone_number) : null;
  const isFR = (currentLang && currentLang === 'fr');

  const cardTop = (
    <div className="mz-dealer-card__top">
      <div className="mz-dealer-card__number">
        <span className="text--white">{index}</span>
        <Svg
          size={2.5}
          colour={isActive ? 'red' : 'grey'}
          type="pin"
        />
      </div>
      <div className="mz-dealer-card__basic-info">
        <p className="mz-dealer-card__name upper ls-md">{name}</p>
        <p className="mz-dealer-card__address font-small ls-normal">{address_line_1}, {city}, {post_code}</p>
        <p className="mz-dealer-card__distance font-small text--grey ls-normal">
          {geolocation.distance && geolocation.distance.toFixed(0) > 0 ? geolocation.distance.toFixed(2) + ' km' : ''}
        </p>
      </div>
    </div>
  )

  return (
    <div className={`mz-dealer-card ${isSelected ? 'selected' : ''}`} ref={el => cardsRef.current[index - 1] = el}>
      <Collapse
        buttonContent={cardTop}
        isActive={isActive}
        onClick={onClick}
      >
        <div className="mz-dealer-card__contact">
          {
            website && (
              <IconText
                label={<Link text={languageController.getCopy('global', 'dealerWebsite')} href={website} target="_blank" />}
                iconType="website"
                iconSize={1}
                iconColour="red"
                iconTop="1px"
                className="caption"
              />
            )
          }
          {
            formattedPhoneNumber && (
              <IconText
                label={<Link text={formattedPhoneNumber} href={`tel:${formattedPhoneNumber}`} />}
                iconType="phone"
                iconSize={1}
                iconColour="red"
                iconTop="1px"
                className="caption"
              />
            )
          }
          <IconText
            label={<Link text={languageController.getCopy('global', 'dealerDirections')} href={generateGoogleDirection(userCurrentPos, { lat: geolocation.latitude, lng: geolocation.longitude })} target="_blank" />}
            iconType="address"
            iconSize={1}
            iconColour="red"
            iconTop="1px"
            className="caption"
          />
        </div>
        <div className="mz-dealer-card__services">
          <p className="font-small upper medium m-t-0">{languageController.getCopy('findDealer', 'availableServices')}</p>
          <div className="mz-dealer-card__services-inner">
            {ev_service && (
              <IconText
                label={languageController.getCopy('findDealer', 'serviceEV')}
                iconType="ev_dealer"
                iconSize={1}
                iconColour="red"
                iconTop="1px"
                className="label"
              />
            )}
            {/* TODO: Manage the following services once the current api has these values */}
            <IconText
              label={<Link className="mz-link--grey" text={languageController.getCopy('findDealer', 'serviceCreditApplication')} href="" target="_blank" />}
              iconType="credit_application"
              iconSize={1}
              iconColour="grey"
              iconTop="1px"
              className="label"
            />
            <IconText
              label={<Link className="mz-link--grey" text={languageController.getCopy('findDealer', 'serviceLiveChat')} href="" target="_blank" />}
              iconType="live_chat"
              iconSize={1}
              iconColour="grey"
              iconTop="1px"
              className="label"
            />
            <IconText
              label={<Link className="mz-link--grey" text={languageController.getCopy('findDealer', 'serviceTradeIn')} href="" target="_blank" />}
              iconType="trade_in"
              iconSize={1}
              iconColour="grey"
              iconTop="1px"
              className="label"
            />
            <IconText
              label={<Link className="mz-link--grey" text={languageController.getCopy('findDealer', 'serviceSMS')} href="" target="_blank" />}
              iconType="sms"
              iconSize={1}
              iconColour="grey"
              iconTop="1px"
              className="label"
            />
            <IconText
              label={<Link className="mz-link--grey" text={languageController.getCopy('findDealer', 'serviceOnlinePurchasing')} href="" target="_blank" />}
              iconType="online_purchasing"
              iconSize={1}
              iconColour="grey"
              iconTop="1px"
              className="label"
            />
          </div>
        </div>
        <div className="mz-dealer-card__hours">
          {
            hours.sales && (
              <Hours
                days={hours.sales}
                isInitOpened={true}
                label={languageController.getCopy('findDealer', 'hoursSales')}
                isNoDrawer={isLean}
                is24HFormat={isFR}
              />
            )
          }
          {
            (hours.parts && !isLean) && (
              <Hours
                days={hours.parts}
                label={languageController.getCopy('findDealer', 'hoursParts')}
                is24HFormat={isFR}
              />
            )
          }
          {
            (hours.service && !isLean) && (
              <Hours
                days={hours.service}
                label={languageController.getCopy('findDealer', 'hoursService')}
                is24HFormat={isFR}
                ctaLink={(
                  <Link
                    className="ls-normal"
                    href={BaSALink}
                    text={languageController.getCopy('findDealer', 'bookServiceCta')}
                    onClick={() => {
                      // Store selected dealer data in localstorage.
                      setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData)
                    }}
                  />
                )}
              />
            )
          }
        </div>
        <div className="mz-dealer-card__cta">
          {
            isLean ? (
              isEmbeddedOnBnP ? (
                <Fragment>
                  <Button
                    label={isSelected ? 'Selected' : languageController.getCopy('findDealer', 'sendBuildToDealer')}
                    className={'mz-btn--primary'}
                    onClick={openSendBuildModal}
                  />
                  <Button
                    label={isSelected ? 'Selected' : languageController.getCopy('findDealer', 'bookTestDriveCta')}
                    className={isSelected ? 'mz-btn--primary' : 'mz-btn--red'}
                    buttonIcon={<Svg type="chevron_small" size={0.75} colour="white" style={{ top: '1px' }} />}
                    buttonIconPosition="right"
                    onClick={onSelect}
                  />
                </Fragment>
              ) : (
                  <Button
                    label={isSelected ? 'Selected' : languageController.getCopy('global', 'selectDealer')}
                    className={isSelected ? 'mz-btn--primary' : 'mz-btn--red'}
                    buttonIcon={<Svg type="chevron_small" size={0.75} colour="white" style={{ top: '1px' }} />}
                    buttonIconPosition="right"
                    onClick={onSelect}
                  />
                )
            ) : (
                <Fragment>
                  <Link
                    text={languageController.getCopy('findDealer', 'bookTestDriveCta')}
                    className="mz-btn mz-btn--red"
                    href={BaTDLink}
                    onClick={() => {
                      // Store selected dealer data in localstorage.
                      setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData)
                    }}
                  />
                  <Link
                    text={languageController.getCopy('findDealer', 'GetQuoteCta')}
                    className="mz-btn mz-btn--secondary"
                    href={GaQLink}
                    onClick={() => {
                      // Store selected dealer data in localstorage.
                      setItemOnLocalStorage(localStorageKeys.DEALER_SELECTED_BY_USER, dealerData)
                    }}
                  />
                </Fragment>
              )
          }
        </div>
      </Collapse>
    </div>
  )
}

DealerCard.propTypes = {
  dealerData: PropTypes.object.isRequired,
  distance: PropTypes.number,
  index: PropTypes.number,
  isActive: PropTypes.bool,
  isLean: PropTypes.bool,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  userCurrentPos: PropTypes.object,
  isSelected: PropTypes.bool,
  BaSALink: PropTypes.string,
  BaTDLink: PropTypes.string,
  GaQLink: PropTypes.string,
  isEmbeddedOnBnP: PropTypes.bool,
  currentLang: PropTypes.string,
}

DealerCard.defaultTypes = {
  isActive: false,
  isLean: false,
  isSelected: false,
  isEmbeddedOnBnP: false,
}

export default DealerCard